<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-6"
  [attr.data-testid]="'rename-dialog-form'"
>
  <div
    class="min-w-[240px] max-w-[500px] p-1.5"
    [attr.data-testid]="'rename-dialog-container'"
  >
    <p class="mb-4" [attr.data-testid]="'rename-dialog-title'">
      重新命名 <span class="text-primary">{{ oriName }}</span>
    </p>

    <mat-form-field
      class="fw tight w-full"
      [attr.data-testid]="'rename-dialog-field'"
    >
      <input
        matInput
        formControlName="name"
        [attr.data-testid]="'rename-dialog-input'"
      />
      <mat-error [attr.data-testid]="'rename-dialog-error'">
        <gosu-form-error [control]="name"></gosu-form-error>
      </mat-error>
    </mat-form-field>

    <div
      class="flex justify-end gap-4"
      [attr.data-testid]="'rename-dialog-buttons'"
    >
      <button
        mat-flat-button
        [mat-dialog-close]="false"
        type="button"
        class="w-20"
        [attr.data-testid]="'rename-dialog-cancel'"
      >
        取消
      </button>
      <button
        mat-flat-button
        type="submit"
        color="primary"
        class="w-20"
        [disabled]="form.invalid"
        [attr.data-testid]="'rename-dialog-submit'"
      >
        確定
      </button>
    </div>
  </div>
</form>
